<template>
  <svg class="svg-icon" :class="className" :style="computedStyle" aria-hidden="true" v-on="$listeners">
    <use :xlink:href="iconName" />
  </svg>
</template>

<script>
export default {
  name: 'SvgIcon',
  props: {
    name: { // 图标名称，对应 SVG 文件名
      type: String,
      required: true
    },
    size: { // 图标尺寸，可以是数字或带单位字符串
      type: [Number, String],
      default: 16
    },
    color: { // 图标颜色
      type: String,
      default: 'currentColor'
    },
    className: { // 自定义类名
      type: String,
      default: ''
    },
    spin: { // 是否旋转
      type: Boolean,
      default: false
    }
  },
  computed: {
    iconName() {
      return `#icon-${this.name}`
    },
    computedStyle() {
      const style = {}
      // 处理尺寸
      if (typeof this.size === 'number') {
        style.width = `${this.size}px`
        style.height = `${this.size}px`
      } else {
        style.width = this.size
        style.height = this.size
      }
      // 处理颜色
      if (this.color) {
        style.color = this.color
      }
      return style
    }
  }
}
</script>

<style lang="less" scoped>
.svg-icon {
  display: inline-block;
  vertical-align: top;
  fill: currentColor; // 关键属性，让 SVG 继承颜色
  transition: all 0.3s;
  margin-right: 5px;

  &.spin {
    animation: spin 1.5s infinite linear;
  }
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}
</style>
